import { styled } from '@linaria/react';
import {
  bodyFont,
  fonts,
  layout,
  primitives,
  semantic,
  shadow,
  size,
  space,
} from '../../theme/tokens';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  padding-bottom: ${space['space-600']};
`;

export const GalleryFrame = styled.div`
  --image-frame-mobile-height: 240px;
  --image-frame-desktop-height: 240px;
  position: relative;
  margin: 0 calc(-1 * ${space['space-600']});
  overflow: hidden;
  border-radius: ${size.radius['radius-lg']} ${size.radius['radius-lg']} 0 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin: ${space['space-600']} 0 0;
    border-radius: 0;
    overflow: visible;
  }
`;

export const GalleryCloseButton = styled.button`
  position: absolute;
  top: ${space['space-300']};
  right: ${space['space-300']};
  width: ${primitives.size['size-800']};
  height: ${primitives.size['size-800']};
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: ${size.radius['radius-full']};
  background: ${semantic.bg.canvas};
  color: ${semantic.text.primary};
  font-size: ${fonts.size.sm};
  line-height: 1;
  cursor: pointer;
  box-shadow: ${shadow.sm};
  z-index: 2;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${space['space-400']};
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;

export const RoomName = styled.h3`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const MetaText = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${space['space-100']};
  flex-shrink: 0;
  text-align: right;
`;

export const StayPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
`;

export const NightPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
`;

export const Description = styled.div`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};

  & p {
    margin: 0;
  }

  & p + p {
    margin-top: ${space['space-300']};
  }
`;

export const FeatureList = styled.ul`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.primary};
  margin: 0;
  padding-left: ${space['space-600']};
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const TotalDueRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${space['space-400']};
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  padding-top: ${space['space-600']};
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
`;

export const TotalDueAmount = styled.span`
  font-weight: ${fonts.weight.medium};
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-300']};
  padding: ${space['space-400']} ${space['space-600']};
`;
